import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Icon } from '../ui';
import fullLogo from '../../assets/full_logo.png';

export default function Navbar({ onLogin, onSignup, showLogin }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <nav className="fixed w-full z-40 px-6 lg:px-8">
      <div className={`max-w-7xl mx-auto transition-all duration-500 ${mobileOpen ? 'py-3' : 'py-5'}`}>
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-4 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <div className="bg-white p-2 rounded-2xl shadow-2xl shadow-indigo-500/20 hover:shadow-indigo-500/30 transition-all duration-300 hover:scale-105">
              <img src={fullLogo} alt="AccountInTime" className="h-10 w-auto object-contain" />
            </div>
          </div>

          <div className="hidden md:flex items-center gap-6">
            <button onClick={onLogin} className={`text-sm font-medium transition-all hover:scale-105 flex items-center gap-2 ${showLogin ? 'text-white font-bold' : 'text-slate-300 hover:text-white'}`}>
              <Icon name="IconUserCircle" size={18} />
              <span>Espace Client</span>
            </button>
            <button onClick={onSignup} className="px-8 py-3 rounded-full bg-gradient-to-r from-indigo-600 to-blue-600 hover:from-indigo-500 hover:to-blue-500 text-white font-bold shadow-2xl shadow-indigo-500/25 transition-all duration-300 hover:scale-105">
              Démarrer l'essai
            </button>
          </div>

          <button onClick={() => setMobileOpen(!mobileOpen)} className="md:hidden text-slate-300 hover:text-white p-2">
            <Icon name={mobileOpen ? "IconX" : "IconMenu2"} size={28} />
          </button>
        </div>
      </div>

      <AnimatePresence>
        {mobileOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="md:hidden bg-slate-900/95 backdrop-blur-xl border border-slate-700/50 rounded-2xl mx-auto max-w-7xl p-6 mt-2"
          >
            <div className="space-y-4">
              <button onClick={() => { onLogin(); setMobileOpen(false); }} className="w-full py-3 px-4 text-left text-slate-300 hover:text-white font-medium flex items-center gap-3 rounded-xl hover:bg-slate-800/50 transition-colors">
                <Icon name="IconUserCircle" size={20} />
                Espace Client
              </button>
              <button onClick={() => { onSignup(); setMobileOpen(false); }} className="w-full py-3 px-4 text-center bg-gradient-to-r from-indigo-600 to-blue-600 text-white font-bold rounded-xl shadow-lg">
                Démarrer l'essai
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
}
